export const HOME = '/home' as const

export * from '@module/AcademicMisconduct/constants/route'
export * from '@module/AcademicYears/constants/route'
export * from '@module/Account/constants/route'
export * from '@module/AchievementRecords/constants/route'
export * from '@module/Assessment/constants/route'
export * from '@module/AssessmentEC/constants/route'
export * from '@module/AssessmentLogs/constants/route'
export * from '@module/AssessmentMarks/constants/route'
export * from '@module/Attendance/constants/route'
export * from '@module/Auth/constants/route'
export * from '@module/Calendar/constants/route'
export * from '@module/Course/create/constants/route'
export * from '@module/Course/activate/constants/route'
export * from '@module/CourseTransfer/constants/route'
export * from '@module/ChatGroup/constants/route'
export * from '@module/DormitoryApp/constants/route'
export * from '@module/Enrollment/constants/route'
export * from '@module/Files/ModuleFiles/constants/route'
export * from '@module/Forms/constants/route'
export * from '@module/Groups/constants/route'
export * from '@module/Lesson/constants/route'
export * from '@module/Meals/constants/route'
export * from '@module/ModuleOutcome/constants/route'
export * from '@module/Modules/create/constants/route'
export * from '@module/Modules/activate/constants/route'
export * from '@module/ModuleRegistration/constants/route'
// export * from '@module/QualityAssurance/constants/'
export * from '@module/Reports/constants/route'
export * from '@module/Roles/constants/route'
// export * from '@module/Semester/constants/'
// export * from '@module/Staff/constants/'
export * from '@module/Student/constants/route'
export * from '@module/StudentDashboard/constants/route'
export * from '@module/TeacherDashboard/constants/route'
export * from '@module/Staff/constants/route'
export * from '@module/HRAdmission/constants/route'
export * from '@module/ShortCourseAdmission/constants/route'
export * from '@module/Library/constants/route'
export * from '@module/JobPosition/constants/route'
export * from '@module/VacancyPosition/constants/route'
export * from '@module/StudentAdmission/constants/route'
export * from '@module/StudentInquiries/constants/route'
export * from '@module/GeneralAdmission/constants/route'
export * from '@module/GuestUsers/constants/route'
export * from '@module/OpenSource/constants/route'
export * from '@module/Payments/constants/route'
export * from '@module/PreFoundation/constants/route'
export * from '@module/ReadersClub/constants/route'
export * from '@module/QuizAssessment/constants/route'
export * from '@module/QuizAssessmentStudent/constants/route'
export * from '@module/Inquiry/constants/route'
export * from '@module/Feedback/constants/route'
export * from '@module/SDFeedback/constants/route'
export * from '@module/ContractInformation/constants/route'
export * from '@module/ShortCourseAdmission/constants/route'
export * from '@module/ShortTermCourse/constants/route'
export * from '@module/Shop/constants/route'
export * from '@module/Timetable/constants/route'
export * from '@module/Vacation/constants/route'
export * from '@module/WorkPlan/constants/route'
export * from '@module/ReservationRoom/constants/route'
export * from '@module/RecruitmentInquiry/constants/route'
export * from '@module/StudentSupport/constants/route'
export * from '@module/NotebookRegistration/constants/route'
export * from '@module/MobileSettings/constants/route'
export * from '@module/DemoLesson/constants/route'
export * from '@module/PreModeration/constants/route'
export * from '@module/HelpDesk/constants/route'
export * from '@module/TeachingWorkload/constants/route'
export * from '@module/Conference/constants/route'
